import image1 from '../assets/3.jpg'
import image2 from '../assets/4.jpg'
import image3 from '../assets/5.jpg'
import image4 from '../assets/6.jpg'
import image5 from '../assets/8.jpg'
import image6 from '../assets/9.jpg'
import image7 from '../assets/About-hero.jpg'
import image8 from '../assets/Contact-hero.jpg'
import image9 from '../assets/img.jpg'
import image10 from '../assets/Montain.jpg'
import video from '../assets/video.mp4'
const product = [
    {
        name: 'Japan',
        description: 'Japan, officially the Republic of Indonesia, is a country in Southeast Asia and Oceania between the Indian and Pacific oceans. It consists of over 17,000 islands, including Sumatra, Java, Sulawesi, and parts of Borneo and New Guinea.',
        image: [image1, image2, image3, image4],
        thumbmail: image1,
        price: 300
    },
    {
        name: 'Indonesia',
        description: 'Indonesi, officially the Republic of Indonesia, is a country in Southeast Asia and Oceania between the Indian and Pacific oceans. It consists of over 17,000 islands, including Sumatra, Java, Sulawesi, and parts of Borneo and New Guinea.',
        image: [image5, image6, image7, image8],
        thumbmail: image2,
        price: 250
    },
    {
        name: 'Colombia',
        description: 'Colombia, officially the Republic of Indonesia, is a country in Southeast Asia and Oceania between the Indian and Pacific oceans. It consists of over 17,000 islands, including Sumatra, Java, Sulawesi, and parts of Borneo and New Guinea.',
        image: [image9, image10, image1, video],
        thumbmail: image3,
        price: 200
    },
    {
        name: 'Argentina',
        description: 'Argentina, officially the Republic of Indonesia, is a country in Southeast Asia and Oceania between the Indian and Pacific oceans. It consists of over 17,000 islands, including Sumatra, Java, Sulawesi, and parts of Borneo and New Guinea.',
        image: [image1, image5, image7, image10],
        thumbmail: image4,
        price: 200
    }
]
export default product